// Item 758: an hourly building's billed months, summed — pure, so a node test
// can read it without the Supabase client (useBilledMonths does the read).
//
// "Before fee and tax": the management fee is its own line (is_management_fee)
// and is left out. No source carries a sales-tax line today (measured
// 2026-10-14), so nothing else is removed and no tax rule is invented.
// ⛔ No average is produced: one averaged figure reads as a rate.

/** One billed month, before the management fee and tax. */
export interface BilledMonthFigure {
  /** ISO first of the month. */
  month: string;
  amount: number;
}

export interface CountedRow {
  counted_month: string | null;
  line_amount: number | string | null;
  is_management_fee: boolean | null;
}

/** Newest `keep` months first, each summed in cents without the management fee. */
export function summariseBilledMonths(rows: ReadonlyArray<CountedRow>, keep = 3): BilledMonthFigure[] {
  const cents = new Map<string, number>();
  for (const r of rows) {
    if (!r.counted_month || r.is_management_fee) continue;
    const n = Number(r.line_amount);
    if (!Number.isFinite(n)) continue;
    cents.set(r.counted_month, (cents.get(r.counted_month) ?? 0) + Math.round(n * 100));
  }
  return [...cents.entries()]
    .sort((a, b) => (a[0] < b[0] ? 1 : -1))
    .slice(0, keep)
    .map(([month, c]) => ({ month, amount: c / 100 }));
}
